/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export const PaymentStatus = {
  pending: "pending",
  approved: "approved",
  accepted: "accepted",
  rejected: "rejected",
  cancelled: "cancelled",
} as const;
